import { useState } from "react";
import { format, parseISO } from "date-fns";
import { CalendarIcon, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

export const DatePicker = ({ value, onChange, testId, placeholder = "Pick a date", disablePast = false, height = "h-10" }) => {
  const [open, setOpen] = useState(false);
  const date = value ? parseISO(value) : undefined;
  return (
    <div className="flex items-center gap-1">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button type="button" data-testid={testId} className={`flex-1 ${height} rounded-md border border-slate-700 bg-slate-950/60 px-3 text-left text-sm flex items-center gap-2`}>
            <CalendarIcon className="h-4 w-4 text-slate-500" />
            <span className={date ? "text-slate-100" : "text-slate-500"}>{date ? format(date, "MMM d, yyyy") : placeholder}</span>
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0 bg-slate-900 border-slate-700" align="start">
          <Calendar mode="single" selected={date} disabled={disablePast ? { before: new Date() } : undefined} onSelect={(d) => { if (d) onChange(format(d, "yyyy-MM-dd")); setOpen(false); }} initialFocus />
        </PopoverContent>
      </Popover>
      {value && <button type="button" data-testid={`${testId}-clear`} onClick={() => onChange("")} className="h-10 px-2 text-slate-500 hover:text-rose-400" aria-label="Clear date"><X className="h-4 w-4" /></button>}
    </div>
  );
};
